// Sentry
// React
import React from 'react'
import ReactDOM from "react-dom/client";
import {reactDomRoot} from "@App/utils/react-dom-root";
// React Router
import {BrowserRouter, Route, Routes} from "react-router-dom"
// Apollo
// Redux
import {Provider} from 'react-redux'
import {store} from '@App/state'
// Pages
import {DbConnect} from "@App/Pages/Partner/DbConnect";
import {Alphabet} from "@App/Pages/Partner/Alphabet";
import {Arval} from "@App/Pages/Partner/Arval";
import {Ayvens} from "@App/Pages/Partner/Ayvens";
import {Athlon} from "@App/Pages/Partner/Athlon";
import {Finn} from "@App/Pages/Partner/Finn";
import {RepareoFunnel} from "@App/Pages";
import {Demo} from "@App/Pages/Partner/Demo";
import {MobilityConcept} from "@App/Pages/Partner/MobilityConcept";
import {ControlExpert} from "@App/Pages/Partner/ControlExpert";
import {LeasePlan} from "@App/Pages/Partner/LeasePlan";
import {Fleethub} from "@App/Pages/Partner/Fleethub";
import {DeutscheLeasing} from "@App/Pages/Partner/DeutscheLeasing";
import {AKF} from "@App/Pages/Partner/AKF";
import {AKFLangzeitMiete} from "@App/Pages/Partner/AKFLangzeitMiete";
import {Ego} from "@App/Pages/Partner/Ego";
import {DeutscheLeasingBosch} from "@App/Pages/Partner/DeutscheLeasingBosch";
import {NIO} from "@App/Pages/Partner/NIO";
import {GM} from "@App/Pages/Partner/GeneralMotors";
import {VehiClever} from "@App/Pages/Partner/VehiClever";
import {Mobexo} from "@App/Pages/Partner/Mobexo";
import {SignalIduna} from "@App/Pages/Partner/SignalIduna";


// i18n
import i18n from "@App/utils/i18n";
import {I18nextProvider} from "react-i18next";
// Sentry
import * as Sentry from "@sentry/react";
import {MeinAuto} from "@App/Pages/Partner/MeinAuto";
import ApolloProvider from './Components/providers/apollo/ApolloProvider';
import {ASS} from "@App/Pages/Partner/ASS";

export function Repareo() {
    return (
        <Provider store={store}>
            <ApolloProvider>
                <I18nextProvider i18n={i18n}>
                    <BrowserRouter basename={"/"}>
                        <Routes>
                            <Route path={"/partner/akf/*"} element={<AKF/>}/>
                            <Route path={"/partner/akf-langzeitmiete/*"} element={<AKFLangzeitMiete/>}/>
                            <Route path={"/partner/alphabet/*"} element={<Alphabet/>}/>
                            <Route path={"/partner/arval/*"} element={<Arval/>}/>
                            <Route path={"/partner/ayvens/*"} element={<Ayvens/>}/>
                            <Route path={"/partner/finn/*"} element={<Finn/>}/>
                            <Route path={"/partner/fleethub/*"} element={<Fleethub/>}/>
                            <Route path={"/partner/dbconnect/*"} element={<DbConnect/>}/>
                            <Route path={"/partner/mobility-concept/*"} element={<MobilityConcept/>}/>
                            <Route path={"/partner/nio/*"} element={<NIO/>}/>
                            <Route path={"/partner/meinauto/*"} element={<MeinAuto/>}/>
                            <Route path={"/partner/controlexpert/*"} element={<ControlExpert/>}/>
                            <Route path={"/partner/leaseplan/*"} element={<LeasePlan/>}/>
                            <Route path={"/partner/deutsche-leasing/*"} element={<DeutscheLeasing/>}/>
                            <Route path={"/partner/deutsche-leasing-bosch/*"} element={<DeutscheLeasingBosch/>}/>
                            <Route path={"/partner/e-go/*"} element={<Ego/>}/>
                            <Route path={"/partner/gme/*"} element={<GM/>}/>
                            <Route path={"/partner/vehiclever/*"} element={<VehiClever/>}/>
                            <Route path={"/partner/ass/*"} element={<ASS/>}/>
                            <Route path={"/partner/athlon/*"} element={<Athlon/>}/>
                            <Route path={"/partner/mobexo/*"} element={<Mobexo/>}/>
                            <Route path={"/partner/demo/*"} element={<Demo/>}/>
                            <Route path={"/partner/signal-iduna/*"} element={<SignalIduna/>}/>
                            <Route path={"/*"} element={<RepareoFunnel/>}/>
                        </Routes>
                    </BrowserRouter>
                </I18nextProvider>
            </ApolloProvider>
        </Provider>
    )
}


Sentry.init({
    dsn: "https://824319c5e9fd4e0ea7c0b17ee22c8121@o189848.ingest.sentry.io/6627087",
    beforeSend(event) {
        try {
            if (event.exception.values[0].stacktrace.frames[0].filename.match(/https:\/\/app.posthog.com\/.*/g)) {
                return null;
            }
        } catch (e) {
        }

        return event;
    },
    denyUrls: [
        /https:\/\/app.posthog.com\/.*/g
    ],
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    replaysOnErrorSampleRate: 1.0,
    release: sentry_release,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: .1,
});


if (document.getElementById('repareo-app')) {
    // const root = ReactDOM.hydrateRoot(document.getElementById('repareo-app'), <Repareo/>)
    const root = ReactDOM.createRoot(reactDomRoot)
    root.render(<Repareo/>)
}
